import React, {useEffect, useRef, useState} from "react";
import {Box, Grid, Img, keyframes, useMediaQuery} from "@chakra-ui/react";
import {domToReact} from "html-react-parser";
import Close from "./images/close.svg"
import Resize from "./images/resize.svg"

export default function LightBox({figure, figureIndex}){

    const figureHtml = domToReact(figure.children)
    const imageSrcSet = figure?.children[2]?.name === "img" ? figure?.children[2]?.attribs['data-srcset'] : figure?.children[0]?.children[2]?.attribs['data-srcset']
    const figureClasses = figure?.attribs?.class


    const figureRef = useRef()

    const imageSrc = imageSrcSet ? imageSrcSet.split(',').pop() : figure?.children[0]?.attribs?.src


    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const [imageWidth, setImageWidth] = useState(0);
    const [elementWidth, setElementWidth] = useState(0);


    const [elemParams, setElemParams] = useState({ width: 0, top: 0, left:0 });


    useEffect(() => {
        const element = figureRef.current;
        if (element) {
            const image = element.querySelector('img');
            const currentElementWidth = element.offsetWidth;
            const currentImageWidth = image.offsetWidth;

            setImageWidth(currentImageWidth)
            setElementWidth(currentElementWidth)

        }
    }, []);

    const openLightbox = (index) => {

        const params = figureRef?.current?.getBoundingClientRect()
        const currentParams = {
            width: params.width,
            top: params.top,
            left: params.left
        };
        setElemParams(currentParams)
        setSelectedImage(index);
        setIsOpen(true);
    };

    const closeLightbox = () => {
        setSelectedImage(null);
        setIsOpen(false);
    };



    const fadeIn = keyframes`  
      from {opacity:0;}   
      to {opacity:1;}
    `;
    const fadeInAnimation = `${fadeIn} .35s forwards ease-in-out`;

    const scale = keyframes`  
      from {transform:scale(0);translate(-50%, -50%);}   
      to {transform:scale(1);translate(-50%, -50%);}   
    `;
    const scaleAnimation = `${scale} .6s forwards cubic-bezier(0.16, 1, 0.3, 1)`;


const isLightBox = elementWidth === imageWidth ? true : false
const [isMobile] = useMediaQuery("(max-width: 768px)")

const opacityState = isLightBox && !isMobile ? '.6 !important' : '1'
    return(
        <>
            <Box as={'figure'} ref={figureRef} className={`wp-block-image ${figureClasses}`} onClick={() => openLightbox(figureIndex)}
                 position={'relative'}
                 sx={{
                     'img': { transition: 'opacity .35s ease' },
                     'figcaption' : {
                         marginTop:'.5rem'
                     }
                 }}
            >
                <Box pos={'relative'} display={'inline-block'} cursor={isLightBox && !isMobile ? 'pointer' : 'default'}
                     _hover={{
                         'img': {
                             opacity: opacityState,
                         },
                         '.resize': {opacity: '1'}
                     }}
                >
                {figureHtml}
                    { isLightBox && !isMobile && (<Box className="resize" pos={'absolute'} opacity={'0'} top={'0'} right={'0'} zIndex={'2'} bgColor={'brand.lightBlue'} color={'#fff'} padding={'.25rem'} transition={'opacity .35s ease'} cursor={'pointer'}>
                        <Box as={Resize} w={'26px'} h={'auto'}/>
                    </Box> )}
                </Box>

            </Box>

            {isOpen && isLightBox && !isMobile && (
                <Grid className="lightbox" placeItems={'center'} pos={'fixed'} inset={'0'} top={'0'} left={'0'} zIndex={'1099'}>
                      <Box className="close"  onClick={closeLightbox} pos={'absolute'} top={'0'} right={'0'} zIndex={'2'} bgColor={'brand.darkBlue'} transition={'background-color .35s ease'}
                           color={'#fff'} cursor={'pointer'} w={'40px'} h={'40px'} display={'flex'} justifyContent={'center'} alignItems={'center'} animation={fadeInAnimation}
                            _hover={{
                                bgColor : 'brand.lightBlue',
                                'svg' : {
                                    transform: 'rotate(180deg)'
                                }
                            }}
                      >
                        <Box as={Close} width={'20px'} transition={'transform .35s ease'}/>
                      </Box>
                   <Box pos={'absolute'} zIndex={'1'} animation={scaleAnimation}  transform={'translate(-50%, -50%)'}><Img src={imageSrc} alt={''} maxHeight={'80dvh'} maxWidth={'90vw'} boxShadow={'0 0 40px rgba(0,0,0,.1)'}/></Box>
                    <Box pos={'absolute'} inset={'0'} top={'0'} left={'0'} zIndex={'0'} bgColor={'rgba(0,0,0,.5)'} cursor={'pointer'} backdropFilter={'blur(4px)'} opacity={'0'} animation={fadeInAnimation} onClick={closeLightbox}/>
                </Grid>
            )}

    </>


    )
}